<template>

  <div v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      </el-tabs>

      <!--基础设置-->
      <Basic v-if="activeName == 'basic'" :form="form" :options="options "></Basic>

      <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
    </el-form>
  </div>
</template>
<script>
import AdvApi from '@/api/adv.js';
import Basic from './part/Basic';
export default {
  components: {
    /*编辑组件*/
    Basic
  },
  data() {
    return {
      /*是否正在加载*/
      loading:true,
      /*当前选中*/
      activeName: 'basic',
      /*数据对象*/
      form:{},
      options:[]
    };
  },
  created() {
    this.activeName="basic"
    this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
     let self = this;
      let Params = {};
      AdvApi.getSetting(Params, true)
        .then(data => {
          console.log(data)
          let vars = data.data.vars.values;
            self.form = vars;
            
            self.loading = false;
        })
        .catch(error => {});
    },
   onSubmit() {
      let self = this;
      let params = self.form
      self.loading = true;
      AdvApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    handleClick(e) {
      this.activeName = e.name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/adv/setting/getSetting.vue